// #region import
import Vue from 'vue'
import VDialog from '@ustra/nuxt-vuetify/src/components/vuetify/v-dialog'
import VNavigationDrawer from '@ustra/nuxt-vuetify/src/components/vuetify/v-navigation-drawer'
// #endregion

// #region register components
Vue.component('v-dialog', VDialog)
Vue.component('v-navigation-drawer', VNavigationDrawer)
// #endregion
